import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d7d682e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group mb-6" }
const _hoisted_7 = { class: "form-label fw-bold" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-label fw-bold mb-3" }
const _hoisted_11 = { class: "course-type-options" }
const _hoisted_12 = { class: "course-type-option" }
const _hoisted_13 = { class: "course-type-option" }
const _hoisted_14 = { class: "course-type-option" }
const _hoisted_15 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "course-filter-modal-overlay",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createElementVNode("div", {
              class: "course-filter-modal",
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.filter`)), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "close-button"
                }, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.search_by_name`)), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: _ctx.$t(`${_ctx.currentLanguage}.page_dashboard.search_by_name`)
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.filters.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.course_type`)), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.types) = $event)),
                        value: "1",
                        class: "form-check-input me-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.filters.types]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.free`)), 1)
                    ]),
                    _createElementVNode("label", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.types) = $event)),
                        value: "2",
                        class: "form-check-input me-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.filters.types]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.members_only`)), 1)
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.types) = $event)),
                        value: "3",
                        class: "form-check-input me-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.filters.types]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.i_have_access`)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                  class: "apply-filter-button"
                }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.apply_filter`)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}